if (!customElements.get('die-cut-shrinking')) {
  const SHRINK_PACK_SIZES = [100, 75, 50, 25];

  customElements.define(
    'die-cut-shrinking',
    class DieCutShrinking extends HTMLElement {
      connectedCallback() {
        this.update = this.update.bind(this);
        this.handleDocumentChange = this.handleDocumentChange.bind(this);
        this.handleDocumentInput = this.handleDocumentInput.bind(this);

        document.addEventListener('change', this.handleDocumentChange);
        document.addEventListener('input', this.handleDocumentInput);
        document.addEventListener('variant:changed', this.update);

        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.handleDocumentChange);
        document.removeEventListener('input', this.handleDocumentInput);
        document.removeEventListener('variant:changed', this.update);
      }

      parseQuantity(value) {
        const match = String(value || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
        return match ? Number(match[0]) : 0;
      }

      getQuantity() {
        const productInfo = this.closest('product-info') || document;
        const customQuantity = productInfo.querySelector('.product_calculator_main.active #ctm_quantity');
        const selectedQuantity = productInfo.querySelector(
          '.sticker-quantity input:checked, .sticker-quantity select'
        );

        return this.parseQuantity(customQuantity?.value || selectedQuantity?.value);
      }

      handleDocumentChange(event) {
        const productInfo = this.closest('product-info');
        if (productInfo?.contains(event.target)) this.update();
      }

      handleDocumentInput(event) {
        const productInfo = this.closest('product-info');
        if (event.target.matches('#ctm_quantity') && productInfo?.contains(event.target)) this.update();
      }

      formatPackCount(packCount) {
        return `${packCount} full ${packCount === 1 ? 'pack' : 'packs'}`;
      }

      formatPrice(cents) {
        return `$${(cents / 100).toFixed(2)}`;
      }

      update() {
        const select = this.querySelector('[data-shrinking-select]');
        const selectLabel = this.querySelector('[data-shrinking-select-label]');
        const packCountOutput = this.querySelector('[data-shrinking-pack-count]');
        const partialPackNote = this.querySelector('[data-shrinking-partial-pack-note]');
        if (!select) return;

        const quantity = this.getQuantity();
        const currentSize = Number(select.value);
        const canSelectCustomPack = quantity >= 100;

        if (selectLabel) {
          selectLabel.textContent = canSelectCustomPack
            ? 'Choose a custom pack size'
            : 'Choose a custom pack size - Minimum quantity is 100';
        }

        Array.from(select.options).forEach((option) => {
          const packSize = Number(option.value);
          option.textContent =
            packSize === 100 ? "Default - Shrinked in 100's" : `Shrinked in ${packSize}'s`;
          option.disabled = !canSelectCustomPack || quantity < packSize;
        });

        if (!canSelectCustomPack || (currentSize !== 100 && quantity < currentSize)) {
          select.value = '100';
        }

        const selectedPackSize = Number(select.value);
        const packCount = Math.floor(quantity / selectedPackSize);
        const remainingQuantity = quantity % selectedPackSize;
        const isIncluded = selectedPackSize === 100;
        select.disabled = !canSelectCustomPack;
        const unitPriceCents = Number(this.dataset.shrinkingUnitPrice || 0);
        select.classList.toggle(
          'shrinking__select--default-unavailable',
          isIncluded && !canSelectCustomPack
        );
        this.dataset.selectedPackCount = String(isIncluded ? 0 : packCount);
        if (packCountOutput) {
          packCountOutput.hidden = isIncluded;
          if (!isIncluded) {
            packCountOutput.textContent = `Total: ${this.formatPrice(
              packCount * unitPriceCents
            )} (${this.formatPackCount(packCount)} @ ${this.formatPrice(unitPriceCents)} each)`;
          }
        }
        if (partialPackNote) {
          partialPackNote.hidden = isIncluded || remainingQuantity === 0;
          if (!isIncluded && remainingQuantity > 0) {
            partialPackNote.textContent = `Note: The remaining ${remainingQuantity} sticker${
              remainingQuantity === 1 ? '' : 's'
            } will be shrink-wrapped in a final partial pack.`;
          }
        }
      }
    }
  );
}
